export default {"src":"/_next/static/media/ra-aircraft-circle.d9f4a553.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};